	<template>

		<div class="pageBox" id="pageBox">
			<!--page start-->
			<div class="login_box">
				<div class="center">
					<img :src="this.banner"  alt="">
				</div>

				<!--账号密码登录-->
				<section class="loginType_01" v-if="this.showPwdLogin">
					<div class="accountLogin">
						<ul>
							<li class="re"> <!--校验错误添加 alert_border 样式-->
								<img src="//images.jinku.com/newjk/h5/images/login/icon01.png" alt="" class="icon ab">
								<input type="text" placeholder="用户名/手机号" class="inputItem fl" v-model.trim="userName">
							</li>
							<li class="re">
								<img src="//images.jinku.com/newjk/h5/images/login/icon02.png" alt="" class="icon ab">
								<input v-bind:type="this.pwdType" placeholder="密码" class="inputItem fl" v-model.trim="userPwd">
								<span class="ab pointer pswToggle pswToggleEvent" v-on:click="showPwd"></span>
							</li>
							<li class="formAlert" v-if="this.showPwdLoginErr">
								{{this.pwdLoginErrMsg}}
							</li>
						</ul>
						<!--
						<div class="slideRegister">
							<div id="slider">
								<div id="slider_bg"></div>
								<span id="label"></span>
								<span id="labelTip">向右滑动验证</span>
							</div>
						</div> -->
						<div class="center btn_box">
							<input type="button" value="登录" class="login_btn" v-on:click="pwdLogin">   <!--激活状态删除 disabled 样式-->
						</div>
						<div class="bottomInfor center">
							<a href="/reset-pwd">忘记密码</a>
							<span>|</span>
							<a class="pointer phoneLoginEvent" v-on:click="showMsgLoginFun">短信登录</a>
						</div>
					</div>
				</section>

				<!--手机登录-->
				<section class="loginType_02 " v-if="this.showMsgLogin">
					<div class="phoneLogin">
						<ul>
							<li class="clearfix"> <!--校验错误添加 alert_border 样式-->
								<input type="text" placeholder="手机号" class="inputItem fl" v-model.trim="mobile">
							</li>
							<li class="clearfix registerNumber">
								<div class="number_box fl re clearfix">
									<input type="text" class="ab number_input numberInputEvent" v-model.trim="smsCode">

									<span class="line"></span>
									<span class="line"></span>
									<span class="line"></span>
									<span class="line"></span>
									<span class="line"></span>
									<span class="line"></span>
								</div>
								<input type="button" value="发送验证码" class="sendCodeBtn fr" v-if="this.sendMsgBefore" v-on:click="sendMsg">
                                <input type="button" value="发送完成" class="sendCodeBtn fr" v-if="this.sendMsgAfter">
							</li>
							<li class="formAlert" v-if="this.showMsgLoginErr">
								{{this.msgLoginErr}}
							</li>
						</ul>

						<div class="btnGroup">
							<a class="btnItem btnItem01 pointer" v-on:click="msgLogin">确认登录</a>
							<a class="btnItem btnItem02 pointer pswLoginEvent" v-on:click="showPwdLoginFun">密码登录</a>
						</div>

						<div class="agreementInfor center">
							注册/登录即代表您同意<a href="https://m.jinku.com/agreement/" target="_blank">《金库网用户注册协议》</a>
						</div>
					</div>
				</section>

			</div>
			<!--page end-->
		</div>

	</template>


<script>
    import http from "../lib/http";
    import common from "../lib/common";

    export default {
        name: 'Login',
        data() {
            return {
                counter:0,
				pwdType: "password",
				userName:"",
				userPwd:"",
                pwdLoginErrMsg:"",
				showPwdLoginErr:false,
                showPwdLogin:true,
                showMsgLogin:false,
                showMsgLoginErr:false,
                mobile:"",
                msgLoginErr:"",
                sendMsgBefore:true,
                sendMsgAfter:false,
                smsCode:"",
                banner:"//images.jinku.com/newjk/h5/images/login/top_icon.png"
            }
        },
        methods: {
			showPwd:function () {
                if (this.counter % 2 == 0) {
                    this.pwdType = "text";
                } else {
                    this.pwdType = "password";
                }
                this.counter++;
            },
            pwdLogin:function () {
			    const self = this;
                this.showPwdLoginErr = false;
				if (this.userName == '' || this.userPwd == ''){
				    this.pwdLoginErrMsg = "用户名密码不能为空";
				    this.showPwdLoginErr = true;
				    //console.log("用户名密码不能为空");
				    return false;
				}
				//ajax 调用登录接口
				http({method: "post", url: "/org/user/login", data: "user_name="+encodeURIComponent(this.userName)+"&password="+encodeURIComponent(this.userPwd)}).then(function (res) {
				    //处理登录返回结果
					//console.log(res);
					if (res.code == 0){ //保存token，并跳转到首页
                        //console.log("登录成功");
                        //token 写入本地存储
                        common.setToken(res.data.token);
                        //跳转到首页
                        self.$router.push('/');
					} else {
                        self.pwdLoginErrMsg = res.mess;
                        self.showPwdLoginErr = true;
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    self.pwdLoginErrMsg = "登录失败请稍后重试";
                    self.showPwdLoginErr = true;

                });
            },
            showMsgLoginFun:function () {
                this.showPwdLogin = false;
                this.showMsgLogin = true;
            },
            showPwdLoginFun:function () {
                this.showPwdLogin = true;
                this.showMsgLogin = false;
            },
            sendMsg:function () {
                const self = this;
                this.showMsgLoginErr = false;
                if (!/^1[3-9]\d{9}$/.test(this.mobile)){
                    this.msgLoginErr = "手机号码异常";
                    this.showMsgLoginErr = true;
                    return false;
                }
                //调用发送短信验证码接口
                http({method: "post", url: "/user/send-code", data: "code_source=1&user_mobile="+encodeURIComponent(this.mobile)+"&area_code="+encodeURIComponent('+86')}).then(function (res) {
                    //处理登录返回结果
                    //console.log(res);
                    if (res.code == 0){ //验证码发送完成
                        self.sendMsgBefore = false;
                        self.sendMsgAfter = true;
                    } else {
                        self.msgLoginErr = res.mess;
                        self.showMsgLoginErr = true;
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    self.msgLoginErr = "发送失败请稍后重试";
                    self.showMsgLoginErr = true;

                });
            },
            msgLogin:function () {
                const self = this;
                this.showMsgLoginErr = false;
                if (!/^1[3-9]\d{9}$/.test(this.mobile)){
                    this.msgLoginErr = "手机号码异常";
                    this.showMsgLoginErr = true;
                    return false;
                }
                if (!/\d{6}/.test(this.smsCode)){
                    this.msgLoginErr = "验证码异常";
                    this.showMsgLoginErr = true;
                    return false;
                }
                //ajax 调用登录接口
                http({method: "post", url: "/org/user/sms-login", data: "user_mobile="+encodeURIComponent(this.mobile)+"&sms_code="+encodeURIComponent(this.smsCode)}).then(function (res) {
                    //处理登录返回结果
                    //console.log(res);
                    if (res.code == 0){ //保存token，并跳转到首页
                        //console.log("登录成功");
                        //token 写入本地存储
                        common.setToken(res.data.token);
                        //跳转到首页
                        self.$router.push('/');
                    } else {
                        self.msgLoginErr = res.mess;
                        self.showMsgLoginErr = true;
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    self.msgLoginErr = "登录失败请稍后重试";
                    self.showMsgLoginErr = true;
                });
            },
            //检测是否登录
            checkLogin:function () {
                const self = this;
                var token = common.getToken();
                if (token){
                    http({method: "post", url: "/org/user/get", data: "token="+token,"redirect":false}).then(function(res){
                        if (res.code == 0 && res.data){
                            self.$router.push('/');
                        }
                    }).catch(function(err){

                    });
                }
            }
        },
        created(){
            var bankJc  = common.getUrlParam("bank_jc");//银行简称
            if(bankJc =="citic"){
                this.banner ="//images.jinku.com/newjk/h5/images/login/zx-logo.png";
            }
            this.checkLogin();
        },

    }
</script>
<style scoped>
    @import "//images.jinku.com/newjk/h5/css/global_mobile.css";
    @import "//images.jinku.com/newjk/h5/css/public.css";
    @import "//images.jinku.com/newjk/h5/css/login.css";
</style>



// WEBPACK FOOTER //
// src/components/login.vue